import { gql } from '@grandvisionhq/graphql';
import AppointmentFragment from '../fragments/appointment.js';

const appointmentById = gql`
  fragment GetAppointmentId on Appointment {
    ...AppointmentFragment
  }
  ${AppointmentFragment}
`;
const GET_APPOINTMENT_BY_ID = gql`
  query getAppointmentById($id: ID!) {
    appointment(id: $id) {
      ...GetAppointmentId
    }
  }
  ${appointmentById}
`;

export { GET_APPOINTMENT_BY_ID };
//# sourceMappingURL=get-appointment-by-id.js.map
